import styled from "@emotion/styled";

const BackgroundImage = styled.div`
	background-image: url(${({ src }) => src});
	background-size: cover;
	background-position: center;
	height: 100%;
	width: 100%;
	transition: 0.2s ease;
`;

export default BackgroundImage